import * as messageTypes from "@/js/eventReport/messageTypes";

export class Signaler {
    static send(eventName, eventParams) {
        if (!eventName) {
            throw new Error(`[EventReport(Signaler)]: eventName is requried.`);
        }

        const message = JSON.stringify({
            type: messageTypes.SUBMIT,
            eventName,
            eventParams
        });

        window.postMessage(message, window.location.origin);
    }
}
